export const resources = {
  de: {
    translations: require("@/i18n/locales/de.json"),
  },
  at: {
    translations: require("@/i18n/locales/at.json"),
  },
  ch: {
    translations: require("@/i18n/locales/ch.json"),
  },
  hu: {
    translations: require("@/i18n/locales/hu.json"),
  },
  pl: {
    translations: require("@/i18n/locales/pl.json"),
  },
  us: {
    translations: require("@/i18n/locales/us.json"),
  }
};
